 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTALSO from '@/components/Text/also'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTFM1 from '@/components/Text/fm1'
 import TEXTPIC from '@/components/Text/pic'
 import TEXTFM2 from '@/components/Text/fm2'
 import TEXTCHAPTER01 from '@/components/Text/Chapter01'
 import TEXTCHAPTER02 from '@/components/Text/Chapter02'
 import TEXTCHAPTER03 from '@/components/Text/Chapter03'
 import TEXTCHAPTER04 from '@/components/Text/Chapter04'
 import TEXTCHAPTER05 from '@/components/Text/Chapter05'
 import TEXTCHAPTER06 from '@/components/Text/Chapter06'
 import TEXTCHAPTER07 from '@/components/Text/Chapter07'
 import TEXTCHAPTER08 from '@/components/Text/Chapter08'
 import TEXTCHAPTER09 from '@/components/Text/Chapter09'
 import TEXTCHAPTER10 from '@/components/Text/Chapter10'
 import TEXTCHAPTER11 from '@/components/Text/Chapter11'
 import TEXTCHAPTER12 from '@/components/Text/Chapter12'
 import TEXTCHAPTER13 from '@/components/Text/Chapter13'
 import TEXTCHAPTER14 from '@/components/Text/Chapter14'
 import TEXTBM from '@/components/Text/bm'
 import TEXTREADINGGROUPGUIDE from '@/components/Text/readinggroupguide'
 import TEXTACKNOWLEDGEMENTS from '@/components/Text/acknowledgements'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTSECTION0002 from '@/components/Text/Section0002'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/fm1",
 			"name" : "Text/fm1",
 			"component" : TEXTFM1
 		},
 		{
 			"path" : "/Text/pic",
 			"name" : "Text/pic",
 			"component" : TEXTPIC
 		},
 		{
 			"path" : "/Text/fm2",
 			"name" : "Text/fm2",
 			"component" : TEXTFM2
 		},
 		{
 			"path" : "/Text/Chapter01",
 			"name" : "Text/Chapter01",
 			"component" : TEXTCHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js